// TODO change to a numeric enum
export enum FilterCategory {
    PILLAR = 'Pillar',
    SUPER_GROUP = 'SuperGroup',
}
